import script from "./Filters.vue?vue&type=script&setup=true&lang=js"
export * from "./Filters.vue?vue&type=script&setup=true&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=55ab24ef&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ab24ef"]])

export default __exports__